import { digitGroup, commonDate } from 'src/helpers'

export const productBulkEditTable = {
  columns: [
    {
      name: 'name',
      field: (row) => {
        const variants = row.variants?.filter(variant => variant?.toLowerCase() !== 'default')
        return `
          <strong>${row.name || '-'}</strong>
          <p class="q-ma-none q-mt-xs">${variants?.length > 0 ? variants : '-'}</p>
        `
      },
      label: 'Nama SKU',
      sortable: true,
      align: 'left',
      rowClass: 'text-left text-no-wrap'
    },
    {
      name: 'supplier_name',
      field: (row) => {
        return `
          <div class="flex column gap-1">
            <span>${row.supplier_name}</span>
            <span class="text-grey-8 q-mt-xs">${row.warehouse}</span>
          </div>
        `
      },
      label: 'Vendor & Gudang',
      sortable: true,
      align: 'left',
      rowClass: 'text-left text-no-wrap'
    },
    {
      name: 'curr_price',
      field: (row) => {
        return `
          <div class="flex column">
            <span>Rp ${digitGroup(row.curr_price)}</span>
            <span class="text-grey-8 q-mt-xs">Diubah ${commonDate({ useDayName: false, date: row.updated_at })}</span>
          </div>
        `
      },
      label: 'Harga Awal',
      sortable: true,
      align: 'right',
      rowClass: 'text-right text-no-wrap'
    }
  ]
}

export const productMainTable = {
  columns: [
    {
      name: 'kategori_1_name',
      field: (row) => {
        return row.kategori_1_name || '-'
      },
      label: 'Kategori 1',
      sortable: true,
      align: 'left'
    },
    {
      name: 'kategori_2_name',
      field: (row) => {
        return row.kategori_2_name || '-'
      },
      label: 'Kategori 2',
      sortable: true,
      align: 'left'
    },
    {
      name: 'kategori_3_name',
      field: (row) => {
        return row.kategori_3_name || '-'
      },
      label: 'Kategori 3',
      sortable: true,
      align: 'left'
    },
    {
      name: 'brand_name',
      field: (row) => {
        return row.brand_name || '-'
      },
      label: 'Merek',
      sortable: true,
      align: 'left',
      rowClass: 'td-width-small'
    },
    {
      name: 'variant_1',
      field: (row) => {
        return row.productVariant &&
          row.productVariant[0].variant &&
          row.productVariant[0].variant[0]
          ? '<div class="text-capitalize text-small">' +
              row.productVariant[0].variant[0]?.value +
              '</div>' +
              `<div class="text-primary text-capitalize">
              <strong>${row.productVariant[0].variant[0]?.label}</strong>
            </div>`
          : '-'
      },
      label: 'Varian 1',
      sortable: false,
      align: 'left',
      rowClass: 'td-width-small'
    },
    {
      name: 'variant_2',
      field: (row) => {
        return row.productVariant &&
          row.productVariant[0].variant &&
          row.productVariant[0].variant[1]
          ? '<div class="text-capitalize text-small">' +
              row.productVariant[0].variant[1]?.value +
              '</div>' +
              `<div class="text-primary text-capitalize">
              <strong>${row.productVariant[0].variant[1]?.label}</strong>
            </div>`
          : '-'
      },
      label: 'Varian 2',
      sortable: false,
      align: 'left',
      rowClass: 'td-width-small'
    },
    {
      name: 'variant_3',
      field: (row) => {
        return row.productVariant &&
          row.productVariant[0].variant &&
          row.productVariant[0].variant[2]
          ? '<div class="text-capitalize text-small">' +
              row.productVariant[0].variant[2]?.value +
              '</div>' +
              `<div class="text-primary text-capitalize">
              <strong>${row.productVariant[0].variant[2]?.label}</strong>
            </div>`
          : '-'
      },
      label: 'Varian 3',
      sortable: false,
      align: 'left',
      rowClass: 'td-width-small'
    },
    {
      name: 'cogs',
      field: (row) => {
        return 'Rp ' + digitGroup(row.cogs) || '-'
      },
      label: 'COGS',
      sortable: true,
      rowClass: 'text-right text-no-wrap',
      align: 'right'
    },
    {
      name: 'retail_price',
      field: (row) => {
        return row.retail_price
          ? `<div class="text-no-wrap">Rp ${digitGroup(
              row.retail_price
            )}</div>` +
              '<div class="text-caption text-primary">' +
              {
                true: 'Otomatis',
                false: 'Manual'
              }[row.flag_retail_manual === false] +
              '</div>'
          : '-'
      },
      label: 'Harga Retail',
      sortable: true,
      rowClass: 'text-right',
      align: 'right'
    },
    {
      name: 'business_price',
      field: (row) => {
        return row.business_price
          ? `<div class="text-no-wrap">Rp ${digitGroup(
              row.business_price
            )}</div>` +
              '<div class="text-caption text-primary">' +
              {
                true: 'Otomatis',
                false: 'Manual'
              }[row.flag_business_manual === false] +
              '</div>'
          : '-'
      },
      label: 'Harga Bisnis Tunai',
      sortable: true,
      rowClass: 'text-right',
      align: 'right'
    },
    {
      name: 'flag_price_manual',
      field: (row) => {
        const badge =
          row.flag_price_manual === false
            ? ['custom-badge-green', 'Otomatis']
            : ['custom-badge-red', 'Manual']
        return `<div role="alert" class="${badge[0]} dense">${badge[1]}</div>`
      },
      label: 'Pengaturan Harga',
      sortable: true,
      align: 'left'
    }
  ]
}

export const priceSubmission = {
  columnsObj: {
    productName: {
      name: 'productName',
      field: (row) => {
        return `
          <strong>${row.productName || '-'}</strong>
          <div>${row.variants || '-'}</div>
        `
      },
      label: 'Nama Produk',
      sortable: true,
      align: 'left'
    },

    supplierName: {
      name: 'supplierName',
      field: (row) => {
        return `
          <strong>${row.supplierName || '-'}</strong>
          <div>${row.warehouseName || '-'}</div>
        `
      },
      label: 'Vendor & Gudang',
      sortable: false,
      align: 'left',
      rowClass: 'td-width-small'
    },
    submissionDate: {
      name: 'submissionDate',
      field: 'submissionDate',
      label: 'Tgl. Pengajuan',
      sortable: false,
      align: 'left',
      commonDate: true
    },
    canceledDate: {
      name: 'canceledDate',
      field: 'canceledDate',
      label: 'Tgl. Pembatalan',
      sortable: false,
      align: 'left',
      commonDate: true
    },
    canceledBy: {
      name: 'canceledBy',
      field: 'canceledBy',
      label: 'Oleh',
      sortable: false,
      align: 'left'
    },
    initialPrice: {
      name: 'initialPrice',
      label: 'Harga Awal',
      field: (row) => {
        let html = row.initialPrice
          ? 'Rp. ' + digitGroup(row.initialPrice)
          : 'Rp. 0'

        html += row.initialPriceUpdatedAt
          ? `<div class="text-caption text-grey-7">Diubah ${commonDate({
              useDayName: false,
              date: row.initialPriceUpdatedAt
            })}</div>`
          : ''

        return html
      },
      sortable: true,
      align: 'right',
      rowClass: 'text-right'
    },
    requestedPrice: {
      name: 'requestedPrice',
      label: 'Harga Diajukan',
      field: (row) => {
        let html = row.requestedPrice
          ? `<div>Rp. ${digitGroup(row.requestedPrice)}</div>`
          : 'Rp. 0'
        const updatePrice = row.initialPrice - row.requestedPrice
        const badge = {
          true: ['red', 'arrow-up'],
          false: ['green', 'arrow-down']
        }[updatePrice < 0]

        html += updatePrice
          ? `
            <div class="custom-badge-${badge[0]} dense">
              <img src="${require(`src/assets/images/icons/${badge[1]}.svg`)}" alt="icon">
              <div class="q-pl-xs" text-weight-bold>Rp. ${digitGroup(Math.abs(updatePrice))}</div>
            </div>
            `
          : '-'

        return html
      },
      sortable: true,
      align: 'right',
      rowClass: 'text-right'
    },

    tag: {
      label: 'Metode Pengiriman',
      name: 'tag',
      field: (row) => {
        function badge (val) {
          const badge = {
            franco: ['custom-badge-blue', 'Franco'],
            loco: ['custom-badge-purple', 'Loco']
          }[val.toLowerCase()] || null

          return `<div class="custom-badge-square ${badge[0]} dense">${badge[1]}</div>`
        }

        const data = []
        if (row.tag) {
          if (row.tag !== row.tagSubmission) data.push(row.tag)
        }
        if (row.tagSubmission) data.push(row.tagSubmission)

        const html = []
        if (Array.isArray(data) && data.length) {
          data.forEach(item => html.push(badge(item)))
        }

        return data.length
          ? `<div class="flex items-center gap-2">
              ${html.join('->')}
            </div>`
          : ''
      },
      align: 'left'
    },
    processedDate: {
      label: 'Tgl. Disetujui',
      name: 'processedDate',
      field: 'processedDate',
      commonDate: true,
      align: 'left',
      rowClass: 'text-left'
    },
    approvalStatus: {
      label: 'Status',
      name: 'approvalStatus',
      field: 'approvalStatus',
      align: 'left',
      rowClass: 'text-left'
    },
    processedBy: {
      label: 'Oleh',
      name: 'processedBy',
      field: (row) => {
        return row.processedBy
          ? `<div class="inline-flex gap-1 items-center">
            <img src="${require('src/assets/images/icons/16x16-user-black.svg')}" alt="">
            <span class="text-capitalize">${row.processedBy}</span>
          </div>`
          : '-'
      },
      align: 'left',
      rowClass: 'text-left'
    }
  },

  waitingColumns: [
    'productName',
    'supplierName',
    'submissionDate',
    'initialPrice'
  ],
  processedColumns: [
    'productName',
    'supplierName',
    'submissionDate',
    'initialPrice',
    'requestedPrice',
    'tag',
    'processedDate'
  ],
  canceledColumns: [
    'productName',
    'supplierName',
    'submissionDate',
    'initialPrice',
    'requestedPrice',
    'tag',
    'canceledDate',
    'canceledBy'
  ]
}

export const productDetailHistoryTable = {
  columns: [
    {
      label: 'Tanggal',
      name: 'date',
      field: 'created_at',
      commonDate: true,
      align: 'left'
    },
    {
      label: 'Perubahan',
      name: 'update',
      field: (row) => {
        let badge = {
          tag: ['custom-badge-blue', 'Pengiriman'],
          cogs: ['custom-badge-green', 'Harga']
        }[row.data.name] || ['custom-badge-red', 'Undefined']
        badge = `<div class="custom-badge-square ${badge[0]} dense">${badge[1]}</div>`

        let value = {
          tag: {
            FRANCO: 'Franco',
            LOCO: 'Loco'
          }[row.data.value],
          cogs: 'Rp ' + row.data.value
        }[row.data.name] || 'Undefined'
        value = `<div>${value}</div>`

        return badge + value
      },
      align: 'left'
    },
    {
      label: 'Aktor',
      name: 'actor',
      field: 'created_by',
      align: 'left',
      rowClass: 'text-capitalize'
    }
  ]
}
